import { Menu } from "antd";
import { RecursiveMenu } from "../../layouts/RecursiveMenu";
import { settings } from "../../../constants/settings";

export const SettingsList = () => (
  <Menu mode="inline">{RecursiveMenu(settings())}</Menu>
);
